export const Insight = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="flex flex-col gap-y-1">
      <div className="text-xl font-bold">{label}</div>
      <div className="text-5xl font-thin"> {value}</div>
    </div>
  );
};
